import React from 'react';
import { useStoreState } from 'easy-peasy';

import Layout from '../../../components/global/Layout';
import {
  useTableSetting,
  useTableSettingPrivate,
} from '../TableBookingSetting/helpers';
import {
  useActionTableBooking,
  usePlaceData2,
} from '../AddModifyBooking/helpers';
import { useTableBookingsDetails } from '../TableBookingManager/helpers';
import Header from './Header';
import CancelBookingForm from './CancelBookingForm';
import { useCancellationChargeByBooking } from '../CancelBooking/helpers';

const useUserRole = () => {
  const { user } = useStoreState(state => state.auth);
  const rolesArray = Array.isArray(user?.role) ? user.role : [];

  let userRole = null;

  const temp = new Map();

  rolesArray.forEach(rls => {
    if (rls === 'kravein_super_admin') {
      temp.set('kravein_super_admin', true);
    } else if (rls.startsWith('kravein_')) {
      temp.set('kravein_admin', true);
    } else if (rls.startsWith('partner_')) {
      temp.set('partner_admin', true);
    }
  });

  if (temp.get('kravein_super_admin')) {
    userRole = 'kravein_super_admin';
  } else if (temp.get('kravein_admin')) {
    userRole = 'kravein_admin';
  } else if (temp.get('partner_admin')) {
    userRole = 'partner_admin';
  }

  return userRole;
};

const RefundBooking = ({ match, history }) => {
  const placeId = match?.params?.placeId;
  const tableBookingId = match?.params?.id;
  const { userId: adminUserId } = useStoreState(state => state.auth);
  const userRole = useUserRole();

  const [
    actionTableBookingLoading,
    actionTableBooking,
  ] = useActionTableBooking();

  const [tableBookingDataLoading, tableBookingData] = useTableBookingsDetails({
    adminUserId,
    tableBookingId,
    reloadTableBookingData: false,
  });

  const [_tableSetting] = useTableSetting({ placeId });
  const [tableSettingPrivate, tableSettingLoading] = useTableSettingPrivate({
    placeId,
  });

  const tableSetting = {
    ..._tableSetting,
    ...tableSettingPrivate,
  };

  const [place, placeLoading] = usePlaceData2({ adminUserId, placeId });

  const [
    cancellationChargeByBookingLoading,
    cancellationChargeByBooking,
  ] = useCancellationChargeByBooking({
    input: {
      table_booking_id: tableBookingId,
      user_id: adminUserId,
    },
  });

  const cancelBookingFormProps = {
    tableBookingData,
    tableSetting,
    place,
    updateTableBooking: {
      func: actionTableBooking,
      loading: actionTableBookingLoading,
    },
    userId: adminUserId,
    userRole,
    charges: cancellationChargeByBooking,
  };

  if (tableBookingDataLoading) {
    return (
      <Layout>
        <Header />
        <div className="m-2">
          <span style={{ color: '#00AEEF', fontSize: '18px' }}>
            Table Booking Data Loading...
          </span>
        </div>
      </Layout>
    );
  }

  if (tableSettingLoading) {
    return (
      <Layout>
        <Header />
        <div className="m-2">
          <span style={{ color: '#00AEEF', fontSize: '18px' }}>
            Table Setting Data Loading...
          </span>
        </div>
      </Layout>
    );
  }

  if (placeLoading) {
    return (
      <Layout>
        <Header />
        <div className="m-2">
          <span style={{ color: '#00AEEF', fontSize: '18px' }}>
            Place Data Loading...
          </span>
        </div>
      </Layout>
    );
  }

  if (cancellationChargeByBookingLoading) {
    return (
      <Layout>
        <Header hideSubmit />
        <div className="m-2">
          <span style={{ color: '#00AEEF', fontSize: '18px' }}>
            Charges Loading...
          </span>
        </div>
      </Layout>
    );
  }

  if (tableBookingData === null || tableSetting === null || place === null) {
    return (
      <Layout>
        <Header />
        <div className="m-2">
          <span style={{ color: 'red', fontSize: '18px' }}>
            Encountered an unexpected error!
          </span>
        </div>
      </Layout>
    );
  }

  return (
    <CancelBookingForm
      cancelBookingFormProps={cancelBookingFormProps}
      history={history}
    />
  );
};

export default RefundBooking;
